import React, { useState, useCallback } from "react";
import { useDetect } from "../contexts/DetectContext.js";
import { useSelector, useDispatch } from "react-redux";
import {
  setUploadedImage,
  setDetectionImage,
  setInferenceTime,
  setIsLoading,
  setNumBoxes,
} from "../features/detectSlice";
import { toast } from "react-toastify";
import * as tf from "@tensorflow/tfjs";
import { useDropzone } from "react-dropzone";
// import useModel from "../hooks/useModel";
import { color_map, processTfjsYOLOOutput } from "../yolo_tf";
import style from "./ImageUpload.module.css";

const ImageUpload = ({ setLlmMessage, setLlmLoading }) => {
  const [imageFile, setImageFile] = useState(null);
  const [prompt, setPrompt] = useState("");
  const dispatch = useDispatch();
  const { cityName } = useSelector((state) => state.model);
  const { uploadedImage } = useSelector((state) => state.detection);

  // useModel(cityName, modelSize);
  const { model } = useDetect();

  // Handle file selection using dropzone
  const onDrop = useCallback(
    (acceptedFiles) => {
      const file = acceptedFiles[0];
      if (file) {
        setImageFile(file);
        dispatch(setUploadedImage(URL.createObjectURL(file))); // Pass the uploaded image to the parent
        dispatch(setDetectionImage(null)); // Reset the processed image
        dispatch(setInferenceTime(0)); // Reset the inference time
      }
    },
    [dispatch] //setUploadedImage, setDetectionImage, setInferenceTime
  );

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: {
      "image/*": [], // Accepts all image types (JPEG, PNG, GIF, etc.)
    },
  });

  const removeUpload = () => {
    setImageFile(null);
    dispatch(setUploadedImage(null));
    dispatch(setDetectionImage(null));
    dispatch(setInferenceTime(0));
    setLlmMessage("");
  };

  const getBase64FromBlob = (blob) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  const handleLLM = async (e) => {
    e.preventDefault(); // Prevent the default form submission
    if (!uploadedImage) {
      toast.error("Please upload an image first!");
      return;
    }
    if (!prompt) {
      toast.error("Please enter a prompt!");
      return;
    }
    setLlmMessage(""); // Update the state with the LLM response
    setLlmLoading(true); // Set loading state to true
    // Fetch the uploaded image as a Blob
    // Fetch the uploaded image as a Blob
    const blob = await (await fetch(uploadedImage)).blob();
    // Convert the Blob to a base64 string
    const base64Image = await getBase64FromBlob(blob);
    // console.log(base64Image);
    
    const url = "http://164.92.204.190:11434/api/generate";
    const payload = {
      model: "gemma3:4b",
      stream: false,
      prompt:prompt,
      // "prompt": "can you see any trash objects near to trash pins, if yes please tell me what are they",
      images: [base64Image.split(",")[1]], // Use the base64 image from the clicked item
      // // "messages": [
      // //   {
      // //     "role": "user",
      // //   },
      // ],
    };
    // console.log(item.image_base64)
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          // Authorization: `Bearer ${token}`, // Add token if required
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error("Failed to fetch LLM response");
      }
      // console.log("LLM Response:", response);
      // const responseText = await response.text();
      // console.log("Raw Response:", responseText);
      const data = await response.json();
      // console.log("LLM Response:", data.response);

      // Extract the description from the response
      const description = data.response || "No description available";
      setLlmMessage(description); // Update the state with the LLM response
      toast.success("LLM Response Received!");
    } catch (error) {
      console.error("Error interacting with LLM:", error);
      setLlmMessage("No description available");
      toast.error("Error interacting with LLM");
    }finally {
      setLlmLoading(false); // Set loading state to false
      setPrompt(""); // Update the state with the LLM response
    }
  };

  // Process the image using the YOLOv11 model
  const processImage = async () => {
    if (!model || !imageFile) return;
    dispatch(setInferenceTime(0));
    const startTime = performance.now();

    dispatch(setIsLoading(true));
    // Load the image
    const img = new Image();
    img.src = uploadedImage;
    await new Promise((resolve) => (img.onload = resolve));

    // Preprocess the image (resize, normalize, etc.)
    const inputSize = 640; // Input size for YOLOv11
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    canvas.width = inputSize;
    canvas.height = inputSize;
    ctx.drawImage(img, 0, 0, inputSize, inputSize);

    const imageData = ctx.getImageData(0, 0, inputSize, inputSize);

    const inputTensor = tf.browser
      .fromPixels(imageData)
      .expandDims(0)
      .div(255.0);

    // Run inference
    // const output = await model.execute(inputTensor);
    // const output = await model.executeAsync(inputTensor);
    const output = model.predict(inputTensor);
    let yolo_classes = [];
    const boxes = processTfjsYOLOOutput(output, 0.7);
    // Draw bounding boxes on the image
    dispatch(setNumBoxes(boxes.length));
    if (cityName === "Tarragona") {
      yolo_classes = ["container"];
    } else {
      yolo_classes = ["Rebuig", "Organic", "Vindre", "Envasos", "Paper"];
    }
    boxes.forEach((box) => {
      const text = `${yolo_classes[box.class]}: ${(
        box.confidence * 100
      ).toFixed(1)}%`;
      const textWidth = ctx.measureText(text).width; // Measure the text width
      const padding = 4; // Padding for the rectangle
      const textHeight = 18; // Height of the text (font size)
      const [x1, y1, x2, y2] = box.bbox;
      // ctx.strokeStyle = "red";
      ctx.strokeStyle = color_map[box.class];
      ctx.lineWidth = 2;
      ctx.strokeRect(x1, y1, x2 - x1, y2 - y1);

      ctx.fillStyle = color_map[box.class];
      ctx.fillRect(
        x1,
        y1 > 20 ? y1 - textHeight - padding : y1 + 20,
        textWidth + padding * 2,
        textHeight + padding
      );

      ctx.fillStyle = box.class === 3 ? "black" : "white";
      ctx.font = "16px Arial";
      ctx.fillText(
        text,
        x1 + padding, // Add padding to the text
        y1 > 20 ? y1 - padding : y1 + 20 + textHeight
      );
    });

    tf.dispose([inputTensor, output, boxes]);

    dispatch(setIsLoading(false));
    dispatch(setDetectionImage(canvas.toDataURL())); // Pass the processed image to the parent
    const endTime = performance.now();
    dispatch(setInferenceTime((endTime - startTime).toFixed(2)));
  };

  return (
    <div className={style.imageUpload}>
      <h2>📷 Upload Image</h2>
      {!uploadedImage ? (
        <div {...getRootProps()} className={style.dropzone}>
          <input {...getInputProps()} />
          <img
            src={`${process.env.PUBLIC_URL}/images/picture.png`}
            alt="Upload"
          />
          <p>Drag & drop an image here, or click to select an image</p>
        </div>
      ) : (
        <>
          <button onClick={processImage}>Detect Containers</button>
          <form className={style.llmForm}>
            <input type="text" value={prompt} placeholder="Ask a LLM..." onChange={(e)=>{setPrompt(e.target.value)}}/>
            <button onClick={(e)=>handleLLM(e)}><img src={`${process.env.PUBLIC_URL}/images/send.png`} alt='send' /></button>
          </form>
          <div className="imageContainer">
            <img src={uploadedImage} alt="Uploaded" />
            <button onClick={removeUpload} className="closeBtn">
              ✖️
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default ImageUpload;
